$(document).on('click','.NewHeader-IconContent',function(){
  $(this).parents('header.header').find('details-modal.header__search summary').click();
});

$(document).on('click','.mediatrigger.card__media',function(){
  window.location = $(this).attr('data-url');
});
 
$(document).on('click','div#CartDrawer-Overlay',function(){
$(this).parents('cart-drawer.drawer').find('.drawer__header button.drawer__close').click();
});

$(document).on('click','body[page-type="schenchrony"] .image-wrapper-bannr',function(){
 window.location.href = 'https://www.synchrony.com/quickaccess/signin/paylater?token=eyJraWQiOiIyMTZiMTQzMC1mOTc2LTQ1NTktYjRhZi0yMzc3OWExODdjM2YiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJ3bk50dkVNRzBIR0wwUWNsWkpsTTVSaUJWVnFJeGZNSSIsImludGVyYWN0aW9uSWQiOiI3ODY1NmU2Yy01M2Y3LTQwMGQtODQ4ZC1lZDE2MDVmMjg2NzAiLCJyZXR1cm5UbyI6Imh0dHBzOlwvXC93d3cuc3luY2hyb255LmNvbVwvcXVpY2thY2Nlc3NcLyIsImlzcyI6ImF1dGguc3lmLmNvbSIsImV4cCI6MTc4OTUzODY5MywiaWF0IjoxNzg5NTM4NjYzLCJqdGkiOiJkNzMxMjgzMS1hZjIwLTQ1YjMtOWE3NS1iMmZiNjE1MzU4ZGYifQ.nxcRNUsETDBq6oOyR3WDcjYAglARVeUJgrS0QK3hD5P-kfDXeCVG6GZdvBmdMgTRJ3PR5m3EfQ_TIUK-xGUBrR6r3dsbFcb-JUHU2-xoLeq-TWnUnDGyMMqZoQVxdLnkCMSOsYLPmOyb1Q2pJQKS6s-YmZsxxjVQHzQmcKj169hQ_fXBnbpFEKqmnuPiA1H-Iaicq07TuAtRKpM5LV23sOStaH6W6ArmHJ-wsOk-j2pM77frR2tOje_tgj08CxJV5f7zmRzo2cNKbYA4D32k9gcyq3yjFedhkQsfR4NKoqY7uWNrmJM0VilNlLmciP2ch9l1COMGNbns2M734Zka-Q&ui_locales=en';
});

$(document).on('click', '.bh-cp-container .bh-cp-cta ,.incognitobutonn a', function (e) {
  e.preventDefault();
  var section = $('.shopify-section.section-start-your-design');
  if (section.length) {
    $('html, body').animate({
      scrollTop: section.offset().top
    }, 600);
  }
});

$(document).on('click', 'body[page-type="custom-jewellery"] .main-banner-new.otherpages .button-containerss a.seondndndn', function (e) {
  e.preventDefault();
  var section = $('.bh-cp-js');
  if (section.length) {
    $('html, body').animate({
      scrollTop: section.offset().top
    }, 600);
  }
});


$(document).on('click', '.bh-jewelry-options__container .bh-jewelry-options__cta', function (e) {
  e.preventDefault();

  var piece = $(this).attr('data-piece');
  var options = $('.syd-type-options [data-syd-type]');

  options.prop('checked', false);

  options.filter(function () {
    return $(this).val() === piece;
  }).prop('checked', true).trigger('change');

  var section = $('.shopify-section.section-start-your-design');

  if (section.length) {
    $('html, body').animate({
      scrollTop: section.offset().top
    }, 600);
  }
});



function checkReadMore() {
  $('.left-block').each(function () {
    const $block = $(this);
    const $message = $block.find('.messsageComplete');
    const $readMore = $block.find('.readmoressss');

    if (!$message.length || !$readMore.length) return;

    // Remove expanded state temporarily so we can measure full content
    const wasExpanded = $message.hasClass('readfull');

    if (wasExpanded) {
      $message.removeClass('readfull');
    }

    const contentHeight = $message[0].scrollHeight;
    const maxHeight = 100;

    if (contentHeight > maxHeight) {
      $readMore.addClass('show-read-more');
    } else {
      $readMore.removeClass('show-read-more');
      $readMore.find('.readmorree').text('read more');
    }

    // Restore expanded state
    if (wasExpanded) {
      $message.addClass('readfull');
    }
  });
}


$(document).on('click', 'span.readmorree', function () {
  const $button = $(this);
  const $message = $button.closest('.left-block').find('.messsageComplete');

  $message.toggleClass('readfull');

  if ($message.hasClass('readfull')) {
    $button.text('read less');
  } else {
    $button.text('read more');
  }
});


// Initial check
$(document).ready(function () {
  checkReadMore();
});


// Re-check when screen size changes
$(window).on('resize', function () {
  checkReadMore();
});

$(document).on('click','.shopify-section.shopify-section-group-header-group.section-header.scrolled-past-header.shopify-section-header-sticky.animate li.searchliadded',function(){
var $this = $(this);
setTimeout(function(){
$this.parents('header.header').find('details-modal.header__search details').attr('open',true);
},100);
});  

$(document).on('click','cart-remove-button .button',function(){
$(this).parents('.cart-item').addClass('removingg');
var $this = $(this);
setTimeout(function(){
$this.parents('.cart-item').removeClass('removingg');
},2500)
});

$(document).on('click','.CategoryPage-FilterBtn ',function(){
  $(this).toggleClass('visiblefilter');
  $(this).parents('body').find('aside#main-collection-filters ,.product-grid-container').toggleClass('visiblefilter');
});

$(document).on('click','p.lifetitme',function(){
  $(this).toggleClass('activee');
  $(this).parents('.rte').find('.onlylifetime').toggleClass('visiblefilterss');
});

$(document).on('click','li.searchliadded svg',function(){
  $('.header .header__icons details-modal.header__search summary').click();
});

$(document).on('click','li.grid__item.imagemodule.mmede',function(){
  console.log('click event previousely');
  window.location = '/collections/ready-to-ship-rings'; 
});

$(document).on('click','.product-engraving-wrapper .accordion-header',function(){
  $(this).toggleClass('active');
  $(this).parents('.product-engraving-wrapper').find('.accordion-content').slideToggle();
});

$(document).on('click','.product .FreeGiftOption',function(){
  $(this).parents('body').find('.Popup.FreeGiftOption-Popup').addClass('active');
  $(this).parents('body').addClass('overlayactive');
});

$(document).on('click','.Popup.FreeGiftOption-Popup .close , .overlaycss',function(){
  $(this).parents('body').find('.Popup.FreeGiftOption-Popup').removeClass('active');
  $(this).parents('body').removeClass('overlayactive');
});

$(document).on('click','.ExpandableContent-Button.ShippingReturnsContent-ExpandableContentButton',function(){
  $(this).parents('article.ShippingReturnsContent-Expandable').toggleClass('closses'); 
});

$(document).on('click','body[page-type=final] .ExpandableContent-Button.ShippingReturnsContent-ExpandableContentButton',function(){
  $(this).parents('.ExpandableContent-Content.ExpandableContent-Content_isContentExpanded').toggleClass('closses'); 
});

$(document).on('click','.product__info-wrapper.grid__item .ProductDetailContent-ConfigrableValue.diamond_origin',function(){
  $(this).addClass('active').siblings().removeClass('active'); 
  var growntext = $(this).find('span').html();
  $(this).parents('.ProductConfigurableAttributes-OptionsWrapper').find('span.ProductConfigurableAttributes-SelectedOptionLabel').html(growntext);
  $('.product  input.labgrowns').attr('value',growntext);
});

$(document).on('change','.product .RingSize_option_Container select',function(){
var vall = $(this).val();
$('.ringsizesss').val(vall);
});

function applyColorMediaMatch($context) {
  var rawColor = $context.attr('matchcolor') || '';
  var dataid   = rawColor.toLowerCase(); 
  var $product = $context.closest('.product');
  var $items = $product.find('.product__media-item.matchinthis');
  $items.removeClass('matched');
  var $matched = $items.filter(function () {
    return ($(this).attr('image-color') || '').toLowerCase() === dataid;
  });
  if (!$matched.length) {
    $matched = $items.filter(function () {
      return ($(this).attr('image-color') || '').toLowerCase() === 'silver';
    });
  }
  $matched.addClass('matched');
}

$(document).on('click','.product__info-wrapper .DialHintSection-Container.share',function(){
$(this).parents('.product__info-wrapper').find('share-button.share-button button').click();
});

$(document).on('click','.product__info-wrapper span.read-more',function(){
$(this).parents('.datinfo').addClass('showall');
});

$(document).on('click','.block-earth',function(){
$(this).addClass('active').siblings('.block-earth').removeClass('active');
});


$(document).on(
  'click',
  'variant-selects.variants-default fieldset.product-form__input label.forcolor',
  function () {
    applyColorMediaMatch($(this));
  }
);

function getNextWeekSameDay(){
  var deliverdays=parseInt($('product-info.productpage').attr('data-delivery-date'));
  if(!deliverdays){
    deliverdays=5;
  }

  const today=new Date();
  today.setDate(today.getDate()+deliverdays);

  return today.toLocaleDateString('en-US',{
    weekday:'short',
    month:'short',
    day:'numeric'
  });
}

var deliveryDate=getNextWeekSameDay();

$('.EstimateDateComponent .shipping-date span,.ProductShipping-EstimateDate span').html(deliveryDate);

if(deliveryDate){
  $('.shippsetime').addClass('show');
}


$(document).ready(function () {
  $('variant-selects.variants-default fieldset.product-form__input label.forcolor.is-selected, \
     variant-selects.variants-default fieldset.product-form__input input:checked + label.forcolor')
    .each(function () {
      applyColorMediaMatch($(this));
    });
});



$('.certification-label').on('click', function () {
  $(this).parent().find('.certification-label').removeClass('certification-label_isSelected');
  $(this).addClass('certification-label_isSelected');

  var datalabel = $(this).attr('data-label');

  var $allInputs = $('details.disclosure-has-popup.facets__disclosure[datacc="Certifications"] ul.destract-Certifications li input');

  // First uncheck everything using label click (IMPORTANT)
  $allInputs.each(function () {
    if ($(this).is(':checked')) {
      $(this).siblings('label').click();
    }
  });

  // If ALL → just stop (everything already unchecked)
  if (datalabel === 'ALL') return;

  // Otherwise click the matching label
  $('details.disclosure-has-popup.facets__disclosure[datacc="Certifications"] ul.destract-Certifications li[data-value="' + datalabel + '"] label').click();
});

$('.DiamondDetails-ListOf_item').on('click', function () {
  $(this).addClass('DiamondDetails-ListOf_item_active').siblings().removeClass('DiamondDetails-ListOf_item_active');
  var htmll = $(this).find('span').html();
  $(this).parents('.DiamondDetails-ContentSection').find('.selectedval').html(htmll)
});


$(document).on('click', '.diamonds-options button.diamonds-option', function () {
    $(this).siblings('button.diamonds-option').removeClass('active');
    var htmll = $(this).find('span').html();
    $('details.disclosure-has-popup.facets__disclosure[datacc="Diamond Origin"] ul.destract-Diamond.Origin li input').prop('checked',false);
    $('details.disclosure-has-popup.facets__disclosure[datacc="Diamond Origin"] ul.destract-Diamond.Origin li[data-value="'+htmll+'"] label').click();
    $(this).addClass('active');
});


$('.advanced-filter-btn').click(function(){
$(this).toggleClass('active');
$(this).parents('body').find('aside#main-collection-filters .facets-container').toggleClass('active');
});


$('.shape-filter').on('click', function (e) {
  e.preventDefault();
  var $this = $(this);
  var datatitle = $this.attr('data-title');
  if ($this.hasClass('active')) {
    $this.removeClass('active');
    $('details.disclosure-has-popup.facets__disclosure[datacc="Shape"] ul.destract-Shape li label')
      .each(function () {
        var input = $(this).find('input[type="checkbox"]');
        if (input.prop('checked')) {
          $(this).click();
        }
      });
    return;
  }
  $('.shape-filter').removeClass('active');
  $this.addClass('active');
  $('details.disclosure-has-popup.facets__disclosure[datacc="Shape"] ul.destract-Shape li label')
    .each(function () {
      var input = $(this).find('input[type="checkbox"]');
      if (input.prop('checked')) {
        $(this).click();
      }
    });
  var matchedLabel = $('details.disclosure-has-popup.facets__disclosure[datacc="Shape"] ul.destract-Shape li[data-value="' + datatitle + '"] label');

  if (matchedLabel.length) {
    matchedLabel.click();
  } else {
    console.log('No match found → all cleared');
  }
});

$(document).on('click', '.CategoryPage-LayoutWrapper button.list', function () {
$(this).addClass('grid_isActive').siblings().removeClass('grid_isActive');
var arialabel = $(this).attr('aria-label');
$(this).parents('body').find('.product-grid-container').attr('aria-style',arialabel);
});

function totaldd(){
var fetchoload = document.querySelector('.fetchcountfrom');
if(fetchoload){
var counttotal = fetchoload.innerHTML;
var diamondcount = document.querySelector('span.total-items.count-all');
var totalcount = document.querySelector('span.total-items.colll');
if(totalcount){
totalcount.innerHTML = `${counttotal} Results`;
}
if(diamondcount){
diamondcount.innerHTML = `(${counttotal})`;
}
}
}

totaldd();

$(document).on('click', '.CategoryPage-LayoutWrapper .reset-container', function () {
    console.log('clicked reset');
    let cleanUrl = window.location.origin + window.location.pathname;
    if(window.location.search){
    window.location = cleanUrl;
    }
});



$(document).on('click', 'tr.diamond-page-list-content', function () {
    let $this = $(this);
    let appendexist = $this.parents('tbody').find('.apeendeddd');
    if (appendexist.length > 0) {
        appendexist.remove();
        $this.removeClass('active');
        return false;
    }
    $this.addClass('active');
    let img = $this.find('td.image-col img').attr('src');
    let title = $this.attr('title');
    let link = $this.attr('urll');
    let carat = $this.find('td[data-label="carat"]').html();
    let color = $this.find('td[data-label="color"]').html();
    let clarity = $this.find('td[data-label="clarity"]').html();
    let cut = $this.find('td[data-label="cut"]').html();
    let price = $this.find('td[data-label="price"]').html();

    let appendhtml = `
<tr class="diamond-page-list-content-contaioner apeendeddd">
   <td colspan="10">
      <div class="diamond-content-contaner">
         <div class="image-contenet">
            <img src="${img}" loading="lazy">
         </div>
         <div class="diamond-contenet">
            <div class="diamond-naem">${title}</div>
            <div class="diamond-price">${price}</div>
            <div class="diamond-value">
               <div class="diamond-value-section"><span>carat:</span><span>${carat}</span></div>
               <div class="diamond-value-section"><span>cut:</span><span>${cut}</span></div>
               <div class="diamond-value-section"><span>color:</span><span>${color}</span></div>
               <div class="diamond-value-section"><span>clarity:</span><span>${clarity}</span></div>
            </div>
            <button class="diamond-detainl-btn"><a href="${link}">View Diamond Details</a></button>
         </div>
      </div>
   </td>
</tr>
`;

    $this.parents('tbody').append(appendhtml);
});




if (window.innerWidth < 768) {
  $(document).on('click', '.flex-o-footer .footer-block.grid__item.footer-block--menu , .footer .flex-o-footer .footer-block--newsletter', function () {
    $(this).toggleClass('activeslide');
  });
}


function checkDiamondShapeMismatch(selected_dia) {
        localStorage.removeItem('diamond_variant_id');
        localStorage.removeItem('diamond_product_handle');
        localStorage.removeItem('diamond_variant_img');
        localStorage.removeItem('diamond_variant_price');
        localStorage.removeItem('diamond_variant_compare_price');
        localStorage.removeItem('slectedDiamond');
        $('.RingSettingIcon.diamonds .spb-wrapper.for-addded.selectedsettings').remove();
        window.location.href = `/collections/natural-diamonds1?filter.v.option.shape=${selected_dia}`;
}


$(document).on('click', '.ProductDetailContent-AddToCartWrapper.rings .selectthisoption-button', function (event) {
    event.preventDefault();
    var parent = $(this).parents('.product__info-wrapper.grid__item');
    var idd = parent.find('input.product-variant-id[name="id"]').val();
    var handle = parent
        .find('.variants-container')
        .attr('prod-handle');
    var selecter = parent
        .find('.variants-container .variantitlee[data-id="' + idd + '"]');
    var img = selecter.attr('imgsrc');
    var price = selecter.attr('var-price');
    var compr = selecter.attr('comp-price');
    var labgrown = parent
        .find('.ProductDetailContent-ConfigrableValue.active span')
        .html();
    // ✅ STEP 1: Store ring data
    var colorSelected = parent.find('fieldset.product-form__input[selected-val="Metal"] input:checked').val();
    localStorage.setItem('selected_colorss', colorSelected);
    localStorage.setItem('selected_variant_id', idd);
    localStorage.setItem('selected_product_handle', handle);
    localStorage.setItem('selected_variant_img', img);
    localStorage.setItem('selected_lab_grown', labgrown);
    localStorage.setItem('selected_variant_price', price);
    localStorage.setItem('selected_variant_compare_price', compr);
    // ✅ STEP 2: First selection check
    if (!localStorage.getItem('first_selected_type')) {
        localStorage.setItem('first_selected_type', 'ring');
    }
    var currnetvar = parent.find('input.product-variant-id').val();
    let liArray = [];
   $(this).parents('.product').find('.grid__item.product__media-wrapper ul.ullalighnes li.product__media-item').each(function () {
            liArray.push($(this).prop('outerHTML'));
        });
    localStorage.setItem('ring_product_slides', JSON.stringify(liArray));
    var lengthh = $('.selectedsettings').length;

    var selected_dia = localStorage.getItem('slectedDiamond');
    var isDiamondSelected = $('.RingSettingIcon.diamonds .spb-wrapper.for-addded.selectedsettings').length === 1;
    var vallls = parent.find('fieldset.product-form__input.product-form__input--pill[selected-val="Shape"] input:checked').val();
    if (selected_dia && isDiamondSelected) {
        if (selected_dia != vallls) {
            checkDiamondShapeMismatch(vallls);
            return;
        }
    }

    if (lengthh >= 1) {
        window.location.href = "/pages/final-page";
    } else {
        window.location.href = `/collections/natural-diamonds1?filter.v.option.shape=${vallls}`;
    }
});


function localrunning(){
    var selection1 = localStorage.getItem('selected_variant_id');
    var selection2 = localStorage.getItem('diamond_variant_id');
    if(!selection1 && !selection2 ){
    window.location = '/collections/natural-diamonds1';
    }
}


document.addEventListener("DOMContentLoaded", function () {
    if(window.location.href.includes('/final-page')){
    localrunning();
    }
    var idd  = localStorage.getItem('selected_variant_id');
    var handle  = localStorage.getItem('selected_product_handle');
    var img   = localStorage.getItem('selected_variant_img');
    var price = localStorage.getItem('selected_variant_price');
    var compr = localStorage.getItem('selected_variant_compare_price');


    if (!idd) return;
    let dddddd = document.querySelector(".RingSettingIcon.ringsss");
   if(dddddd){
    dddddd.innerHTML = `
        <div class="spb-wrapper for-addded selectedsettings" data-id="${idd}">
         <div class="maker">
            <div class="spb-prices">
                <span class="compare-price">${compr}</span>
                <span class="main-price">${price}</span>
            </div>
            <div class="spb-actions">
                <a handle="${handle}" idd="${idd}" class="ring_product" href="/products/${handle}?variant=${idd}">View</a>
                <span class="divider">|</span>
                <a href="/collections/ring">Change</a>
            </div>
            </div>
            <div class="spb-image">
                <img src="${img}" alt="Selected Variant">
            </div>
        </div>
    `;
   }
});



$(document).on('click', '.ProductDetailContent-AddToCartWrapper.not-rings .selectthisoption-button', function (event) {
    event.preventDefault();
    var parent = $(this).parents('.product__info-wrapper.grid__item');
    var slectedDiamond = parent
        .find('fieldset.product-form__input[selected-val="Shape"] span.selectedvarian')
        .html();
    var idd = parent
        .find('input.product-variant-id[name="id"]')
        .val();
    var handle = parent
        .find('.variants-container')
        .attr('prod-handle');
    var selecter = parent
        .find('.variants-container .variantitlee[data-id="' + idd + '"]');
    var img = selecter.attr('img-src');
    var price = selecter.attr('var-price');
    var compr = selecter.attr('comp-price');
    // ✅ STEP 1: Collect diamond media (FIXED)
    let liArrayss = [];
    $(this).parents('.product').find('.grid__item.product__media-wrapper ul.product__media-list li.product__media-item').each(function () {
            liArrayss.push($(this).prop('outerHTML'));
      });
    // ✅ STEP 2: Store separately (IMPORTANT)
    localStorage.setItem('diamond_product_slides', JSON.stringify(liArrayss));
    // ✅ STEP 3: Store other data
    localStorage.setItem('slectedDiamond', slectedDiamond);
    localStorage.setItem('diamond_variant_id', idd);
    localStorage.setItem('diamond_product_handle', handle);
    localStorage.setItem('diamond_variant_img', img);
    localStorage.setItem('diamond_variant_price', price);
    localStorage.setItem('diamond_variant_compare_price', compr);
    if (!localStorage.getItem('first_selected_type')) {
        localStorage.setItem('first_selected_type', 'diamond');
    }
    // localStorage.removeItem('selected_variant_id');
    // localStorage.removeItem('selected_product_handle');
    // localStorage.removeItem('selected_variant_img');
    // localStorage.removeItem('selected_lab_grown');
    // localStorage.removeItem('selected_variant_price');
    // localStorage.removeItem('selected_variant_compare_price');
    // 🚀 Navigation
    var lengthh = $('.selectedsettings').length;
    if (lengthh >= 1) {
        window.location.href = "/pages/final-page";
    } else {
        window.location.href = `/collections/ring?diamond=${slectedDiamond}`;
    }
});


document.addEventListener("DOMContentLoaded", function () {

    var idd = localStorage.getItem('diamond_variant_id');
    var handle = localStorage.getItem('diamond_product_handle');
    var img = localStorage.getItem('diamond_variant_img');
    var price = localStorage.getItem('diamond_variant_price');
    var compr = localStorage.getItem('diamond_variant_compare_price');


    if (!idd) return;
    let dddddd = document.querySelector(".RingSettingIcon.diamonds");
   if(dddddd){
    dddddd.innerHTML = `
        <div class="spb-wrapper for-addded selectedsettings" data-id="${idd}">
         <div class="maker">
            <div class="spb-prices">
                <span class="compare-price">${compr}</span>
                <span class="main-price">${price}</span>
            </div>
            <div class="spb-actions">
                <a class="diamond_product" idd="${idd}" href="/products/${handle}?variant=${idd}">View</a>
                <span class="divider">|</span>
                <a href="/collections/natural-diamonds1">Change</a>
            </div>
            </div>
            <div class="spb-image">
                <img src="${img}" alt="Selected Variant">
            </div>
        </div>
    `;
   }

    let first = localStorage.getItem('first_selected_type');
    if (!first) return;
    let ringsStep = document.querySelector(".RingSettingIcon:not(.diamonds)");
    let diamondStep = document.querySelector(".RingSettingIcon.diamonds");
    let stepsWrapper = document.querySelector(".StepSection"); 
    if (!stepsWrapper || !ringsStep || !diamondStep) return;
    if (first === 'ring') {
        stepsWrapper.classList.add('ringsStep');
    } else if (first === 'diamond') {
        stepsWrapper.classList.add('diamondsStep');
        $('.StepSection.diamondsStep .step-options[diamond="diamonds-block"] span.step-number').html(1)
        $('.StepSection.diamondsStep .step-options[diamond="rings-block"] span.step-number').html(2)
    }
});



function clearStepLocalStorage() {
    // ring details
    localStorage.removeItem('selected_variant_id');
    localStorage.removeItem('selected_product_handle');
    localStorage.removeItem('selected_variant_img');
    localStorage.removeItem('selected_variant_price');
    localStorage.removeItem('selected_variant_compare_price');

    // diamond details
    localStorage.removeItem('diamond_variant_id');
    localStorage.removeItem('diamond_product_handle');
    localStorage.removeItem('diamond_variant_img');
    localStorage.removeItem('diamond_variant_price');
    localStorage.removeItem('diamond_variant_compare_price');

    // first selected type
    localStorage.removeItem('first_selected_type');
    // location.reload();
}
 
const currentpagess = window.location.pathname.split('/')[2];

if(currentpagess == 'final-page'){

function formatMoney(cents) {
    if (!cents) return "$0";
    cents = parseInt(cents, 10);
    let value = (cents / 100).toFixed(2);
    return "$" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}




async function renderVariantInfo(handle, variantId, targetSelector) {
  
    if (!handle || !variantId || !targetSelector) return;

    try {
        const productRes = await fetch(`/products/${handle}.js`);
        const product = await productRes.json();

        const variant = product.variants.find(v => v.id == variantId);
        if (!variant) return;

        const title = product.title || "";
        const metalType = variant.option1 || "";
        const shape = variant.option2 || "";
        const sku = variant.sku && variant.sku.trim() !== "" ? variant.sku : (product.sku || "");

        const compareCents = variant.compare_at_price || 0;
        const comparePrice = compareCents ? formatMoney(compareCents) : "";
        const priceCents = variant.price || 0;
        const mainPrice = formatMoney(priceCents);

        let discountPercent = "";
        if (compareCents > priceCents) {
            const percent = Math.round(((compareCents - priceCents) / compareCents) * 100);
            discountPercent = percent + "% off";
        }

        var anotherpstion = document.querySelector('.skuringproduct');
        if (anotherpstion) {
            anotherpstion.innerHTML = sku;
        }
        const diamondOrigin = localStorage.getItem('selected_lab_grown');
        const html = `
            <h1 class="ring-title">${title}</h1>
            <div class="config-option">
                ${metalType ? `<div class="value metal_type"><span><strong>Metal Type&nbsp;</strong>${metalType}</span></div>` : ``}
                ${shape ? `<div class="value shape"><span><strong>Shape&nbsp;</strong>${shape}</span></div>` : ``}
                <div class="value diamond_origin">
                    <span><strong>Diamond Origin&nbsp;</strong>${diamondOrigin}</span>
                </div>
                <div class="value sku">
                    <span><strong>SKU&nbsp;</strong>${sku}</span>
                </div>
            </div>
            <div class="ProductActions-PriceWrapper">
                <div class="CustmizeRingOptionPrice">
                    <div class="ProductPrice ProductPrice-Price">
                        <del class="ProductPrice-HighPrice">${comparePrice}</del>
                        <span class="ProductPrice-Price">
                            <span class="ProductPrice-PriceValue mainprice">${mainPrice}</span>
                        </span>
                        <div class="ProductActions-DiscountPrice-Price">
                            <span class="ProductActions-Discount">${discountPercent}</span>
                        </div>
                    </div>
                </div>
            </div>`;
        document.querySelector(targetSelector).innerHTML = html;
        
const imgSrc = variant.featured_image ? variant.featured_image.src : "";

if (imgSrc) {

    let galleryHTML = `<div class="gallery-image main-image">`;

    // ✅ Track duplicates
    let usedImages = new Set();
    usedImages.add(imgSrc);

    // ✅ Main image first
    galleryHTML += `
        <div class="image-item">
            <img src="${imgSrc}" style="width:100%; height:auto; display:block;">
        </div>
    `;

    // ✅ Get separate storage
    let ringSlides = [];
    let diamondSlides = [];

    try {
        ringSlides = JSON.parse(localStorage.getItem('ring_product_slides')) || [];
        diamondSlides = JSON.parse(localStorage.getItem('diamond_product_slides')) || [];
    } catch (e) {
        console.warn('Storage parse error');
    }
var choosedShape = localStorage.getItem('slectedDiamond');
var choosedColor = localStorage.getItem('selected_colorss');
     
ringSlides.forEach(li => {
    let tempDiv = document.createElement('div');
    tempDiv.innerHTML = li;
    let realLi = tempDiv.querySelector('li');
    let shapesss = realLi ? realLi.getAttribute('data-shape-num') : '';
    let colorVal = realLi ? realLi.getAttribute('data-selected-color') : '';
    if (choosedShape && shapesss !== choosedShape) return;
    if (choosedColor && colorVal !== choosedColor) return;
    let img = realLi ? realLi.querySelector('img') : null;
    let video = realLi ? realLi.querySelector('video') : null;
    if (img && !usedImages.has(img.src)) {
        usedImages.add(img.src);
        galleryHTML += `
            <div class="image-item" 
                 data-shape-num="${shapesss}" 
                 data-selected-color="${colorVal}">
                <img src="${img.src}" style="width:100%; height:auto; display:block;">
            </div>
        `;
    }
    if (video && video.src && !usedImages.has(video.src)) {
        usedImages.add(video.src);
        galleryHTML += `
            <div class="image-item video-item"
                 data-shape-num="${shapesss}" 
                 data-selected-color="${colorVal}">
                <video 
                    src="${video.src}" 
                    autoplay 
                    muted 
                    loop 
                    playsinline
                    style="width:100%; height:auto; display:block;">
                </video>
            </div>
        `;
    }
});
    diamondSlides.forEach(li => {
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = li;

        let img = tempDiv.querySelector('img') || tempDiv.querySelector('.product__media img');
        let video = tempDiv.querySelector('video');

        // ✅ IMAGE
        if (img && !usedImages.has(img.src)) {
            usedImages.add(img.src);

            galleryHTML += `
                <div class="image-item">
                    <img src="${img.src}" style="width:100%; height:auto; display:block;">
                </div>
            `;
        }

if (video) {
    let sourceTag = video.querySelector('source');
    let videoSrc = sourceTag ? sourceTag.getAttribute('src') : video.getAttribute('src');

    if (videoSrc) {
        galleryHTML += `
            <div class="image-item">
                <video 
                    class="custom-video"
                    muted 
                    loop 
                    playsinline 
                    autoplay
                    style="width:100%; height:auto;"
                >
                    <source src="${videoSrc}" type="video/mp4">
                </video>
            </div>
        `;
    }
}
    });

    galleryHTML += `</div>`;

    document.querySelector(".final-page-url .product-image-gallery").innerHTML = galleryHTML;
}

    } catch (error) {
        console.error("Error loading variant info:", error);
    }
}




async function getDiamondOptionHTML(productUrl, targetSelector) {
    try {
        const url = new URL(productUrl, window.location.origin);
        const handle = url.pathname.split("/products/")[1];
        const variantId = url.searchParams.get("variant");
        if (!handle || !variantId) return;
        const res = await fetch(`/products/${handle}.js`);
        const product = await res.json();
        const variant = product.variants.find(v => v.id == variantId);
        if (!variant) return;
        const fmt = (cents) => "$" + (cents / 100).toLocaleString();
        const variantPrice = fmt(variant.price);
        const comparePrice = variant.compare_at_price ? fmt(variant.compare_at_price) : "";
        const title = product.title || "";
        const skuValue = variant.sku && variant.sku.trim() !== "" ? variant.sku : (product.sku || "");
        const html = `
            <h1 class="ring-title">${title}</h1>
            <div class="config-option">
                <div class="value"><span><strong>SKU&nbsp;</strong>${skuValue}</span></div>
            </div>

            <div class="ProductActions-PriceWrapper">
                <div class="CustmizeRingDiamondOptionPrice">
                    <div class="CustmizeRingOptionPrice">
                        <div class="ProductPrice ProductPrice-Price">
                            <span class="ProductPrice-Price">
                                <span class="ProductPrice-PriceValue mainprice">${variantPrice}</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>`;

        document.querySelector(targetSelector).innerHTML = html;

    } catch (err) {
        console.error("Error loading diamond option:", err);
    }
}

setTimeout(function() {
var ringone =  $('a.ring_product').attr('handle');
var ringtwo =  parseInt($('a.ring_product').attr('idd'));
var diamondone =  $('a.diamond_product').attr('href');
const urll = new URL(diamondone, window.location.origin);
const handlee = urll.pathname.split('/products/')[1];
diamonddetailsfetch(handlee);
getDiamondOptionHTML(diamondone,".ring-option-details.diamondd");
renderVariantInfo(ringone, ringtwo, ".final-page-url .ring-option-details");
}, 800);


setTimeout(function() {
var jointtitle = '';
var titles = $('.final-page-url .ring-title')
    .map(function () {
        return $(this).html();
    })
    .get();
jointtitle = titles.join(' with ');
$('.final_product_details h1.ProductPage-Title').html(jointtitle);
var total = 0;
$(".final_product_details span.ProductPrice-PriceValue.mainprice").each(function () {
    var priceText = $(this).text().trim();
    var priceNum = parseFloat(priceText.replace(/[$,]/g, '')) || 0;
    total += priceNum;
});
var finalTotal = "$" + total.toLocaleString();
$(".final-page-url .ProductPrice.ProductPrice-Price .finalprice").text(finalTotal);
$('.loader-spinner').hide();
}, 1500);



$(document).on('click', '.final-page-url .AddToCart', function () {
  var items = [];
  var $this = $(this);
  var selectedSize = $('.final-page-url select').val();
  var hasValidSize = selectedSize && selectedSize.trim() !== "" && selectedSize !== "please select";
  if (!hasValidSize) {
    $('body[page-type=final] .ring-size-error').show();
    setTimeout(function () {
      $('body[page-type=final] .ring-size-error').hide();
    }, 1500);
    return;
  }
  var bundleTimestamp = Date.now();
  $this.addClass('loading');
  $this.find('span').html('Adding...');
  var idOne = $('a.ring_product').attr('idd');
  var idTwo = $('a.diamond_product').attr('idd');
  items.push({
    id: idOne,
    quantity: 1,
    properties: {
      Size: selectedSize,
      _bundle_id: bundleTimestamp
    }
  });
  items.push({
    id: idTwo,
    quantity: 1,
    properties: {
      _bundle_id: bundleTimestamp
    }
  });
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      items: items
    },
    dataType: 'json',
    success: function () {
      $this.find('span').html('Added');
      clearStepLocalStorage();
      $this.removeClass('loading');
      window.location = '/cart';
    },
    error: function () {
      $this.find('span').html('Add To Cart');
      $this.removeClass('loading');
      alert('Added all items to your cart');
    }
  });
});




function diamonddetailsfetch(handle){

fetch(`/products/${handle}?section_id=diamond-details`)
  .then(res => res.text())
  .then(html => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const selectorrr = doc.querySelector('.DiamondSpecifications-ProductDetailsTabs .ProductAttributes-Attributes');
    console.log(selectorrr,'selectorrr');
    document.querySelector('.ExpandableContent-Content.ExpandableContent-Content_isContentExpanded .ProductAttributes-Attributes.diamonddetails')
      .innerHTML = selectorrr ? selectorrr.innerHTML : '';
  })
  .catch(err => console.error(err));

}

}


$(document).on('click','.GiftOptionComponent .gift-options0-form .gift-ooptions-button-container button',function (e) {
    e.preventDefault();
    var $textarea = $(this).closest('.GiftOptionComponent').find('textarea[name="message"]');
    var noteText = $.trim($textarea.val());
    var $this = $(this);
    $(this).addClass('loadingg');
    $.ajax({
      url: '/cart.js',
      method: 'POST',
      contentType: 'application/json',
      data: JSON.stringify({
        note: noteText
      }),
      success: function () {
        $this.removeClass('loadingg');
        alert('Note updated successfully');
      },
      error: function (err) {
        console.error(err);
        $this.removeClass('loadingg');
      }
    });
  }
);



$(document).on('click', 'p.cart-remove-items', function (e) {
  e.preventDefault();
  var $this = $(this);
  var bundleId = $this.attr('bundleid');
  if (!bundleId) return;
  $this.addClass('loading');
  var updates = {};
  $('tr.bundle_item[bundlematch="' + bundleId + '"]').each(function () {
    var itemId = $(this).attr('itemid');
    if (itemId) {
      updates[itemId] = 0;
    }
  });
  if ($.isEmptyObject(updates)) {
    $this.removeClass('loading');
    return;
  }
  $.ajax({
    type: 'POST',
    url: '/cart/update.js',
    data: {
      updates: updates
    },
    dataType: 'json',
    success: function (data) {
      if (data.item_count !== undefined) {
        $('#CartCount span:first').text(data.item_count);
      }
      window.location.reload();
    },
    error: function () {
      $this.removeClass('loading');
      alert('Unable to remove bundle items. Please try again.');
    }
  });
});


(function () {

  const DISCOUNT_CODE = 'VAL20%';
  let isApplyingDiscount = false;

  function refreshCartItems() {
    return fetch(`${routes.cart_url}?section_id=cart-drawer`)
      .then(res => res.text())
      .then(responseText => {

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const source = html.querySelector('cart-drawer');
        const target = document.querySelector('cart-drawer');

        if (source && target) {
          target.innerHTML = source.innerHTML;
        }

        console.log('✅ Cart refreshed');
      });
  }

  function applyDiscount() {

    if (isApplyingDiscount) return;
    isApplyingDiscount = true;

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: DISCOUNT_CODE })
    })
    .then(() => {
      console.log('✅ Discount applied');
      return refreshCartItems();
    })
    .finally(() => {
      setTimeout(() => {
        isApplyingDiscount = false;
      }, 800);
    });

  }

  // 🔥 Intercept real Shopify fetch calls
  const originalFetch = window.fetch;

  window.fetch = function () {
    return originalFetch.apply(this, arguments).then(response => {

      const url = arguments[0];

      if (
        typeof url === 'string' &&
        (url.includes('/cart/add') || url.includes('/cart/change'))
      ) {
        setTimeout(() => {
          applyDiscount();
        }, 600);
      }

      return response;
    });
  };

  console.log('🔥 Fetch-based auto discount active');

})(); 




// PLUS
$(document).on('click', '.show-more-trigger', function () {
  const isMobile = window.innerWidth < 768;
  const hiddenClass = isMobile ? 'is-hidden-option-mob' : 'is-hidden-option';
  const $fieldset = $(this).closest('fieldset.product-form__input');
  localStorage.setItem('variantToggleState', 'expanded'); // ✅ store
  $fieldset.removeClass('removeplus').addClass('visibleminus');
  $fieldset.find('label').removeClass(hiddenClass);
});


// MINUS
$(document).on('click', 'label.forcolorplusiconss.minussssssss', function () {
  const isMobile = window.innerWidth < 768;
  const hiddenClass = isMobile ? 'is-hidden-option-mob' : 'is-hidden-option';
  const $fieldset = $(this).closest('fieldset.product-form__input');
  localStorage.setItem('variantToggleState', 'collapsed'); // ✅ store
  $fieldset.addClass('removeplus').removeClass('visibleminus');
  const $minus = $(this);
  const $plus = $minus
    .prevAll('label.forcolorplusiconss.plusssssss:visible')
    .first();
  $plus.nextUntil($minus).addClass(hiddenClass);
});
 
$(document).on('click', '.buynow-new-btn p.buyyy', function (e) {
  var $this = $(this);
  $this.addClass('active');
  e.preventDefault();
  var $form = $(this).parents('form');

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: $form.serialize(), 
    dataType: 'json',
    success: function () {
    setTimeout(function() {
    $this.removeClass('active');
    }, 800);
      window.location.href = '/checkout'; 
    },
    error: function (err) {
      console.error(err);
    setTimeout(function() {
    $this.removeClass('active');
    }, 800);
      alert('Something went wrong. Please try again.');
    }
  });
});


const interval = setInterval(() => {
  const shopifyWrapper = document.querySelector('.shopify-payment-button');
  const gravityBtn = document.querySelector('gravity-button.accelerated-checkout-button');
  if (shopifyWrapper && gravityBtn) {
    const width = shopifyWrapper.offsetWidth;
    gravityBtn.style.width = width + 'px';
    gravityBtn.style.borderRadius = '40px';
    gravityBtn.style.overflow = 'hidden';
    clearInterval(interval);
  }

}, 300);


 
function getColorVariantMap() {
  const el = document.querySelector('.optionscontainerproduct');
  if (!el) return;
  const variants = JSON.parse(el.dataset.variants);
  const colorMap = {};
  variants.forEach(variant => {
    const color = variant.option1; 
    if (!color) return;
    if (!colorMap[color]) {
      colorMap[color] = variant.id;
    }
  });
  return colorMap;
}


const colorVariantMap = getColorVariantMap();
console.log('colorVariantMap',colorVariantMap);




function renderDiamondImagesOnRingPage() {
    if (!window.location.pathname.includes('/products')) return;
    if (document.body.getAttribute('page-type') !== 'rings') return;
    var lengthh = document.querySelectorAll('.StepSection .step-options[diamond=diamonds-block] .spb-wrapper.for-addded.selectedsettings').length;
    if (lengthh !== 1) return;
    let diamondSlides = [];
    try {
        diamondSlides = JSON.parse(localStorage.getItem('diamond_product_slides')) || [];
    } catch (e) {
        console.warn('Diamond slides parse error');
        return;
    }
    if (!diamondSlides.length) return;
    let targetUL = document.querySelector('ul.ullalighnes');
    if (!targetUL) return;
    let diamondHTML = '';
    diamondSlides.forEach(li => {
        let tempDiv = document.createElement('div');
        tempDiv.innerHTML = li;
        let img = tempDiv.querySelector('img') || tempDiv.querySelector('.product__media img');
        if (img && img.src) {
            diamondHTML += `
                <li class="product__media-item slider__slide activee">
                    <img src="${img.src}" alt="Diamond Image" style="width:100%; height:auto;">
                </li>
            `;
        }
    });
    targetUL.insertAdjacentHTML('beforeend', diamondHTML);
}

function autoExpandIfHiddenSelected() {
    const isMobile = window.innerWidth < 768;
    const $checked = $('fieldset.product-form__input input:checked');
    if (!$checked.length) return false;
    let triggered = false; 
    $checked.each(function () {
        const id = $(this).attr('id'); 
        const $label = $('label[for="' + id + '"]'); 
        const $fieldset = $(this).closest('fieldset.product-form__input');

        // Desktop
        if (!isMobile && $label.hasClass('is-hidden-option')) {
            $fieldset.find('.show-more-trigger.desktops').trigger('click');
            triggered = true;
        }

        // Mobile
        if (isMobile && $label.hasClass('is-hidden-option-mob')) {
            $fieldset.find('.show-more-trigger.mobiles').trigger('click');
            triggered = true;
        }
    });

    return triggered;
}

$(document).ready(function () {
    if (!window.location.pathname.includes('/collections/')) return;
    const params = new URLSearchParams(window.location.search);
    let shape = params.get('filter.v.option.shape');
    if (shape) {
        shape = shape.toLowerCase();
        $('.shape-filter[data-title="' + shape + '"]').addClass('active'); // change class if needed
    }
});
 

$(window).on('load', function () {
    let tries = 0;
    const interval = setInterval(function () {
        const done = autoExpandIfHiddenSelected();
        if (done || tries > 10) {
            clearInterval(interval);
        }
        tries++;
    }, 200);
});


$(document).on(
  'mousedown',
  '.shopify-section-header-sticky .header__icons details-modal.header__search summary.header__icon.header__icon--search.header__icon--summary span.svg-wrapper',
  function (e) {
    e.preventDefault(); // stop native toggle
    $(this).closest('details').prop('open', true);
  }
);

$(document).on('click', 'span.size-chart', function () {
  window.open(
    'https://cdn.shopify.com/s/files/1/0766/9986/1205/files/bh_ring_size_guide.pdf?v=1776258843',
    '_blank'
  );
});


